import { ReactNode } from "react";

export class PurchaseItemsPriceModel {
  id: string;
  title: string;
  discount: number;
  surcharge: number;
  tax: number;
  subTotal: number;
  shipping: number;
  dueLater: boolean;
  titleAsNode?: ReactNode;
  constructor(data?: Partial<PurchaseItemsPriceModel>) {
    this.id = data?.id || "";
    this.title = data?.title || "";
    this.discount = data?.discount || 0;
    this.surcharge = data?.surcharge || 0;
    this.tax = data?.tax || 0;
    this.subTotal = data?.subTotal || 0;
    this.shipping = data?.shipping || 0;
    this.dueLater = data?.dueLater || false;
    this.titleAsNode = data?.titleAsNode;
  }

  get totalPrice(): number {
    const totalPrice =
      this.subTotal - this.discount + this.tax + this.surcharge + this.shipping;
    return totalPrice <= 0 ? 0 : totalPrice;
  }
}
